package fr.frux.feature.treedetail

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberUpdatedState
import kotlinx.coroutines.flow.Flow

/**
 * Évènements one-shot de la fiche. Suppression réussie (#224) : la fiche n'a plus rien à
 * afficher, l'hôte décide de la sortie ([onTreeDeleted], par défaut le retour). Correction sans
 * compte : l'écran ouvre la connexion.
 *
 * Les callbacks sont lus au moment de l'évènement et non capturés à la première composition :
 * sur js, `stringResource` vaut "" au premier rendu, et l'hôte peut changer entre-temps.
 */
@Composable
internal fun TreeDetailEventsEffect(
    events: Flow<TreeDetailEvent>,
    onTreeDeleted: () -> Unit,
    onLogin: () -> Unit,
) {
    val currentOnTreeDeleted by rememberUpdatedState(onTreeDeleted)
    val currentOnLogin by rememberUpdatedState(onLogin)
    LaunchedEffect(events) {
        events.collect { event ->
            when (event) {
                TreeDetailEvent.Deleted -> currentOnTreeDeleted()
                TreeDetailEvent.LoginRequired -> currentOnLogin()
            }
        }
    }
}
